import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';


/**
 * Component for use with react-router-dom to scroll the window to the top of the page after navigation.
 *
 * Taken from:
 * https://reactrouter.com/web/guides/scroll-restoration/scroll-to-top
 *
 * @returns {null}
 */
export function ScrollToTop() {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0,0);
    }, [pathname]);

    return null;
}
